import React, { PropsWithChildren, useMemo } from 'react'

import { Grid, Typography } from '@barracuda-internal/bds-core'

export type FormTextProps = {
  id?: string
}

export const FormText = ({ children, id }: PropsWithChildren<FormTextProps>) =>
  useMemo(
    () => (
      <Grid container justifyContent="flex-start">
        <Typography variant="body1" id={id}>
          {children}
        </Typography>
      </Grid>
    ),
    [children, id]
  )
